import React from 'react';
import VasantPanchami from '../assets/Events/vp.png';
import Mahashivratri from '../assets/Events/shivratri.jpeg';
import sundarkaand from '../assets/Events/SunderKaand_Paath/6.jpeg';
import shri_ahswin_kumar_pathak from '../assets/shri_ahswin_kumar_pathak.jpg';
import hanuman_dada from '../assets/hanuman_dada.jpg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import EventCard from './EventCard';

const Events = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const pastEvents = [
    {
      src: shri_ahswin_kumar_pathak,
      title: 'SunderKaand MahaPaath & MahaPrasad',
      description:
        'The mandir hosted a divine <strong>SunderKaand MahaPaath & MahaPrasad</strong> on <strong>May 4, 2024</strong> at Exchange Place Plaza, Jersey City. It was an evening filled with devotion, blessings, and community togetherness with <strong>Guruji Ashwin Kumar Pathak</strong>.',
    },
    
    {
      src: hanuman_dada,
      title: 'Hanuman Jayanti',
      description:
        'The mandir celebrated <strong>Hanuman Jayanti</strong> with great fervor on <strong>April 11, 2024</strong>. The celebration included SunderKaand Paath, MahaAarti, and Mahaprasad.',
    },
  ];

  return (
    <div className="events-section w-[90%] mt-[20px] mx-auto">
      {/* Past Events */}
      <h2 className="text-2xl text-[40px] md:text-[60px] mt-[20px] font-abhaya mb-2 text-[#800000] text-center">
        Past Events
      </h2>
      <div className="mt-[40px] flex justify-center">
        {pastEvents.length > 2 ? (
          <div className="w-full">
            <Slider {...settings}>
              {pastEvents.map((event, index) => (
                <EventCard
                  key={index}
                  imageSrc={event.src}
                  title={event.title}
                  description={event.description}
                  cardType={'Past'}
                />
              ))}
            </Slider>
          </div>
        ) : (
          <div className="flex flex-wrap justify-center gap-6">
            {pastEvents.map((event, index) => (
              <EventCard
                key={index}
                imageSrc={event.src}
                title={event.title}
                description={event.description}
                cardType={'Past'}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
